import { render, staticRenderFns } from "./profile-socials.vue?vue&type=template&id=210c8d2d&scoped=true&"
import script from "./profile-socials.vue?vue&type=script&lang=js&"
export * from "./profile-socials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210c8d2d",
  null
  
)

export default component.exports